"use client"
import { useIsDesktop } from "common/MediaQueries"
import ContentWithForm from "reusable/ContentWithForm"
import { getServiceInstructions } from "../../api/delek"
import { ButtonType, ContentItemType } from "../../typings/contentPage"

const ServiceInstructionsPage = () => {
  const buttons: ButtonType[] = [
    { value: "licenseNumber", name: "מס׳ לוחית רישוי" },
    { value: "chassis", name: "מס׳ שלדה" },
  ]

  const isDesktop = useIsDesktop()

  const headerText = !isDesktop
    ? [
        `הוראות שירות הינה פניה יזומה של יצרן הרכב אל בעל הרכב שמטרתה ביצוע של בדיקה ו/או פעולה מונעת
    ו/או תיקון ברכב`,
      ]
    : [
        `הוראות שירות הינה פניה יזומה של יצרן הרכב אל בעל הרכב שמטרתה ביצוע של בדיקה ו/או פעולה מונעת`,
        `ו/או תיקון ברכב`,
      ]

  return (
    <ContentWithForm
      title="בדיקת הוראת שירות"
      headerText={headerText}
      background={[
        "/img/Serviceinstructionsmobile.jpg",
        "/img/Serviceinstructions.jpg",
      ]}
      subtitle="כדי לבדוק אם קיימת בקשה להוראת שירות למאזדה שלך, יש להקליד כאן את מספר לוחית הרישוי או השלדה"
      buttons={buttons}
      inputLabel={`מספר לוחית רישוי
      (משמאל לימין)`}
      inputType="text"
      submitText="לבדיקה"
      bottomTitle="שירות הלקוחות שלנו זמין בשבילך לכל עניין:"
      phoneNumber="*2880"
      getData={getServiceInstructions}
      type={ContentItemType.RECALL}
      page={"instructions"}
      breadCrumbName={"ServiceInstructions"}
    />
  )
}

export default ServiceInstructionsPage
